<template>
	<div id="agaccount" class='gcardfr' v-loading='loading'>
		<el-row :gutter="20" class=''>
			<el-col :span='16'>
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addTer'>{{ $t('app_add_account') }}</el-button>
				<!-- <el-button size='small' @click="batchDel" :disabled="sRows.length == 0" type='danger' plain>批量删除</el-button>     -->
			</el-col>
			<el-col :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('app_select_account') }}：</label>
					<el-input size='small' v-model='srcKey' @keyup.enter.native="indexget" :placeholder="$t('app_nick_name')"></el-input>
				</div>
			</el-col>
			<!-- <el-col :span='8'> 
        <div class="glineflex">
          <label class="glinelb">渠道商：</label>    
          <Merchant :config='sortMc'></Merchant>
        </div>        
      </el-col>  -->
		</el-row>
		<!-- @selection-change="batchSelected" ref="multipleTable" -->
		<el-table class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="account" :label="$t('app_login_account')" width="">
			</el-table-column>
			<el-table-column prop="nickname" :label="$t('app_nick_name')" width="">
			</el-table-column>
			<el-table-column prop="phone" :label="$t('app_mobile_phone')" width="">
			</el-table-column>
			<el-table-column prop="agentName" width="146":label="$t('app_provider')">
			</el-table-column>
			<el-table-column prop="status" :label="$t('app_status')" :formatter="setStatus" width="80">
			</el-table-column>
			<el-table-column prop="status" :label="$t('app_role')":formatter="setRole" width="100">
			</el-table-column>
			<el-table-column prop="createtime" :label="$t('app_add_time')"  width="176">
			</el-table-column>
			<el-table-column :label="$t('app_operation')" width="140">
				<template slot-scope="scope">
					<el-button type='text' @click='editRow(scope.row)'>{{$t('app_edit')}}</el-button>
					<label class='opbline'>|</label>
					<el-button @click='delRow(scope.row.account)' type='text' class='opdcolor'>{{$t('app_delete')}}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog @close="closeDia" class='gstdia' :title="isEdit? $t('app_edit_account'): $t('app_add_account')" :visible.sync="showDia">
			<el-form :model="uform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('app_login_account')" :label-width="$formlbWidth" prop='account'>
					<el-input :disabled="isEdit" v-model="uform.account" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_nick_name')" :label-width="$formlbWidth" prop='nick'>
					<el-input v-model="uform.nick" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_telephone')" :label-width="$formlbWidth" prop='phone'>
					<el-input v-model="uform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop='merchant'>
					<Merchant :config='editMc'></Merchant>
				</el-form-item>
				<el-form-item :label="$t('app_role')" :label-width="$formlbWidth" prop='role'>
					<el-select size="middle" v-model="uform.role" clearable style="width: 100%;" placeholder="请选择"
						cchange="onChange">
						<el-option v-for="item in $isAdminType()?$roles:$roles1" :key="item.vl" :label="item.lb"
							:value="item.vl">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('app_status')" :label-width="$formlbWidth">
					<el-radio v-model="uform.status" label="0">{{ $t('app_disabled') }}</el-radio>
					<el-radio v-model="uform.status" label="1">{{ $t('app_enable') }}</el-radio>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="rqsBefore">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div> -->
		</el-dialog>

	</div>
</template>

<style>
	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from '@/components/Pages.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				sortMc: {},
				editMc: {},
				isEdit: false,
				srcKey: '',
				pconfig: '',
				tableData: [],
				showDia: false,
				uform: {
					id: '',
					account: '',
					nick: '',
					phone: '',
					merchant: '',
					role: '',
					status: '0'
				},
				page: 1,
				total: 0,
				loading: false,
				sRows: [],
				rules: {
					account: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					nick: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					merchant: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					role: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}]
				}
			}
		},
		components: {
			Pages,
			Merchant
		},
		methods: {
			indexget() {
				this.page = 1
				this.getList()
			},
			setRole(row) {
				return this.$roleSt[row.roleName];
			},
			setStatus(row) {
				return this.$agAcSt[row.status]
			},
			rqsBefore() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_delete_question_2'), () => {
					var arr = []
					this.sRows.forEach(item => {
						arr.push(item.id)
					})
					this.delRqs(arr.toString())
				}, '')
			},
			editRow(row) {
				this.isEdit = true
				// this.uform.id = row.account
				this.uform.account = row.account
				this.uform.nick = row.nickname
				this.uform.phone = row.phone
				this.uform.status = row.status
				this.uform.merchant = row.agentId
				this.uform.role = row.roleId
				this.setMcCtr(row.agentId.split(','))
				this.showDia = true
			},
			delRqs(id) {
				this.loading = true
				this.$delAgChild(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			delRow(id) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(id)
				}, '')
			},
			addTer() {
				this.isEdit = false
				this.setMcCtr('')
				this.showDia = true
			},
			getList() {
				this.loading = true
				// var terminalNo = 
				var agentId = this.srcKey ? this.srcKey : ''
				this.$agentChildList(this.page, this.$gRow, agentId, res => {
					this.loading = false
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			batchSelected(val) {
				this.sRows = val
			},
			closeDia() {
				this.$refs['ruleForm'].resetFields()
				this.showDia = false
				this.uform.userId = ''
				this.uform.account = ''
				this.uform.nick = ''
				this.uform.phone = ''
				this.uform.status = '0'
				this.uform.role = ''
			},
			okDia() {
				var fm = this.uform
				this.loading = true

				if (this.isEdit) {
					//// eidt 
					this.$editAgentChild(fm.account, fm.nick, fm.merchant, fm.phone, fm.status, fm.role, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, '')
				} else {
					/////  add
					this.$addAgentChild(fm.account, fm.nick, fm.merchant, fm.phone, fm.status, fm.role, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					}, '')
				}
			},
			setMcCtr(vl) {
				this.editMc = {}
				var _this = this
				this.editMc = {
					// type:'0', 
					// vlkey: 'agentId',
					isbc: true,
					size: '',
					value: vl,
					callback: (cvl) => {
						_this.uform.merchant = cvl.toString()
					}
				}
			}
		},
		mounted() {
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

			this.sortMc = {
				size: 'small',
				value: '',
				callback: (vl) => {
					// alert(vl)
				}
			}

			this.getList()
		}
	}
</script>
